document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', function () {
  const menuButton = document.querySelector('.menu');
  const navigation = document.querySelector('header nav');

  function closeMenu() {
    navigation?.classList.remove('is-open');
    menuButton?.setAttribute('aria-expanded', 'false');
  }

  menuButton?.setAttribute('aria-expanded', 'false');
  menuButton?.addEventListener('click', function () {
    const isOpen = navigation?.classList.toggle('is-open') || false;
    menuButton.setAttribute('aria-expanded', String(isOpen));
  });
  navigation?.addEventListener('click', function (event) {
    if (event.target.closest('a')) closeMenu();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeMenu();
  });

  const consentKey = 'nutri-elixir-cookie-consent';

  function readConsent() {
    try { return JSON.parse(localStorage.getItem(consentKey)); } catch (error) { return null; }
  }

  function applyConsent(consent) {
    try { localStorage.setItem(consentKey, JSON.stringify(consent)); } catch (error) {}
    if (window.Shopify?.customerPrivacy?.setTrackingConsent) {
      window.Shopify.customerPrivacy.setTrackingConsent({
        analytics: Boolean(consent.analytics),
        marketing: Boolean(consent.marketing),
        preferences: Boolean(consent.preferences),
        sale_of_data: false
      }, function () {});
    }
  }

  function openCookieSettings() {
    document.querySelector('[data-cookie-layer]')?.remove();
    const saved = readConsent() || {};
    document.body.insertAdjacentHTML('beforeend', `
      <div class="cookie-layer" data-cookie-layer>
        <button class="cookie-scrim" type="button" data-cookie-close aria-label="Close cookie settings"></button>
        <section class="cookie-panel" role="dialog" aria-modal="true" aria-labelledby="CookieSettingsTitle">
          <h2 id="CookieSettingsTitle">Cookie settings</h2>
          <p>Choose which optional cookies Nutri Elixir may use. Necessary cookies remain enabled for essential Shopify functions such as the cart and checkout.</p>
          <div class="cookie-options">
            <label><span><b>Necessary</b><small>Required for essential store functions.</small></span><input type="checkbox" checked disabled></label>
            <label><span><b>Preferences</b><small>Remember choices that improve your experience.</small></span><input type="checkbox" data-consent-preferences ${saved.preferences ? 'checked' : ''}></label>
            <label><span><b>Analytics</b><small>Help us understand how the store is used.</small></span><input type="checkbox" data-consent-analytics ${saved.analytics ? 'checked' : ''}></label>
            <label><span><b>Marketing</b><small>Allow relevant marketing and campaign measurement.</small></span><input type="checkbox" data-consent-marketing ${saved.marketing ? 'checked' : ''}></label>
          </div>
          <div class="cookie-actions">
            <button class="outline" type="button" data-cookie-reject>Reject optional</button>
            <button class="outline" type="button" data-cookie-save>Save choices</button>
            <button class="cta" type="button" data-cookie-accept>Accept all</button>
          </div>
          <small>See our <a href="/pages/privacy">Privacy Policy</a> for more information.</small>
        </section>
      </div>
    `);
    const layer = document.querySelector('[data-cookie-layer]');
    layer?.querySelector('.cookie-panel button')?.focus();

    function finish(consent) {
      applyConsent(consent);
      layer?.remove();
    }

    layer?.querySelector('[data-cookie-close]')?.addEventListener('click', function () { layer.remove(); });
    layer?.querySelector('[data-cookie-reject]')?.addEventListener('click', function () {
      finish({ necessary: true, preferences: false, analytics: false, marketing: false });
    });
    layer?.querySelector('[data-cookie-accept]')?.addEventListener('click', function () {
      finish({ necessary: true, preferences: true, analytics: true, marketing: true });
    });
    layer?.querySelector('[data-cookie-save]')?.addEventListener('click', function () {
      finish({
        necessary: true,
        preferences: Boolean(layer.querySelector('[data-consent-preferences]')?.checked),
        analytics: Boolean(layer.querySelector('[data-consent-analytics]')?.checked),
        marketing: Boolean(layer.querySelector('[data-consent-marketing]')?.checked)
      });
    });
  }

  document.querySelectorAll('[data-cookie-settings]').forEach(function (button) {
    button.addEventListener('click', openCookieSettings);
  });

  if (!readConsent()) openCookieSettings();
});
